<div class="action-dropdown">
  <ion-item lines="none" button (click)="export('clear')">
    <ion-label>
      Remove Selections From Bundle
    </ion-label>
  </ion-item>
</div>
